import React, { useState, useEffect } from 'react';
import { useField, useFormikContext } from 'formik';
import { TextField } from "@mui/material";
import AdapterDateFns from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { useTranslation } from "react-i18next";
import useMUIStyleHelper from '../UseMUIStyleHelper';

export default function CsplDateField(props) {
  const [field, meta, helper] = useField(props);
  const { touched, error } = meta;
  const { setValue } = helper;
  const isError = touched && error && true;
  const { value, name } = field;
  const [selectedDate, setSelectedDate] = useState(null);
  const { t } = useTranslation("common");
  const dateDisplayFormat="DD-MM-YYYY";
  const { setFieldTouched } = useFormikContext();
  const { mandatoryClasses, nonMandatoryClasses } = useMUIStyleHelper();

  useEffect(() => {
    if (value) {
      const date = new Date(value);
      setSelectedDate(date);
    }else{
      setSelectedDate(null);
    }
  }, [value]);

  function _onChange(date) {
    setFieldTouched(name,true);
    if (date) {
      setSelectedDate(date);
      try {
        const ISODateString = date.toISOString();
        if(ISODateString){
          setValue(date.format("YYYY-MM-DD"));
        }        
      } catch (error) {
        setValue(date);
      }
    } else {
      setValue(date);
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
    <>
    {props.required ?
    <DatePicker
        {...field}
        {...props}
        value={selectedDate}
        onChange={_onChange}
        inputFormat={dateDisplayFormat}
        fullWidth
        mask="__-__-____"
        format="DD-MM-YYYY"
        renderInput={(params) => (
          <TextField
            {...params}
            error={isError}
            helperText={isError && error}
            label={t(props.label)}
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }} 
            required={props.required}
            className={mandatoryClasses.root}
          />
        )}
      />
:
<DatePicker
        {...field}
        {...props}
        value={selectedDate}
        onChange={_onChange}
        inputFormat={dateDisplayFormat}
        fullWidth
        mask="__-__-____"
        format="DD-MM-YYYY"
        renderInput={(params) => (
          <TextField
            {...params}
            error={isError}
            helperText={isError && error}
            label={t(props.label)}
            size="small"
            fullWidth
            required={props.required}
            InputLabelProps={{ shrink: true }}
            className={nonMandatoryClasses.root}
          />
        )}
      />
    }
    </>
     
    </LocalizationProvider>
  );
}
